import { ChangeDetectorRef, Injectable } from '@angular/core';
import { act, Actions, createEffect, ofType } from '@ngrx/effects';
import {
  map,
  catchError,
  tap,
  exhaustMap,
  filter,
} from 'rxjs/operators';
import { of } from 'rxjs';
import * as fromEncodingActions from '../actions/encoding.action';
import { Store } from '@ngrx/store';
import { AppState } from '../app.state';
import { setLoadingSpinner } from '../actions/shared.action';
import { ModalService } from 'src/app/services/modal.service';
import { EncodingService } from 'src/app/services/encoding.service';
import { ROUTER_NAVIGATION, RouterNavigatedAction } from '@ngrx/router-store';
import { Router } from '@angular/router';
import { getApplicantDetails } from '../actions/account.action';

@Injectable()
export class EncodingEffects {

  queues$ = createEffect(
    ()=> this.actions$.pipe(
      ofType(ROUTER_NAVIGATION),
      filter((r : RouterNavigatedAction) => {
        return r.payload.routerState.url.startsWith('/home/queue');
      }),
      exhaustMap((action) => 
        this.encodingService.getQueues().pipe(
          map((response)=>{
            console.log('getQueues$', response);
            return fromEncodingActions.getQueuesSuccess({data: response})
          }),
          catchError((response)=>{
            this.store.dispatch(setLoadingSpinner({status : false}));
            return of(fromEncodingActions.getQueuesFailed({data : response?.error?.message}))
          })
        )
      )
    )
  );

  getQueues$ = createEffect(
    ()=> this.actions$.pipe(
      ofType(fromEncodingActions.getQueues),
      exhaustMap((action) => 
        this.encodingService.getQueuesByUrl(action?.data).pipe(
          map((response)=>{
            console.log('getQueues$', response);
            this.store.dispatch(setLoadingSpinner({status: false}))
            return fromEncodingActions.getQueuesSuccess({data: response})
          }),
          catchError((response)=>{
            this.store.dispatch(setLoadingSpinner({status : false}));
            return of(fromEncodingActions.getQueuesFailed({data : response?.error?.message}))
          })
        )
      )
    )
  );

  getQueuesSuccess$ = createEffect(
    ()=> this.actions$.pipe(
        ofType(fromEncodingActions.getQueuesSuccess),
        tap(async (action) =>{
          console.log("getQueuesSuccess$", action.data);
        })
      ),
    { dispatch: false }
  );

  getQueuesFailed$ = createEffect(
    ()=> this.actions$.pipe(
        ofType(fromEncodingActions.getQueuesFailed),
        tap(async (action) =>{
          console.log("getQueuesFailed$", action.data);
          if(action.data){
            const message = action.data
            this.modalService.errorModal(message)
          } else{
            const message = 'Unkown error ocurred. Please try again later.'
            this.modalService.errorModal(message)
          }
        })
      ),
    { dispatch: false }
  );

  getDemographics$ = createEffect(
    ()=> this.actions$.pipe(
      ofType(ROUTER_NAVIGATION),
      filter((r : RouterNavigatedAction) => {
        return r.payload.routerState.url.startsWith('/home/application')
        || r.payload.routerState.url.startsWith('/home/edit-application');
      }),
      exhaustMap((action) => 
        this.encodingService.getDemographics().pipe(
          map((response)=>{
            console.log('getDemographics$', response);
            return fromEncodingActions.getDemographicsSuccess({data: response})
          }),
          catchError((response)=>{
            this.store.dispatch(setLoadingSpinner({status : false}));
            return of(fromEncodingActions.getDemographicsFailed({data : response?.error?.message}))
          })
        )
      )
    )
  );

  getOtherOptions$ = createEffect(
    ()=> this.actions$.pipe(
      ofType(ROUTER_NAVIGATION),
      filter((r : RouterNavigatedAction) => {
        return r.payload.routerState.url.startsWith('/home/application')
        || r.payload.routerState.url.startsWith('/home/edit-application');
      }),
      exhaustMap((action) => 
        this.encodingService.getOtherOptions().pipe(
          map((response)=>{
            console.log('getOtherOptions$', response);
            return fromEncodingActions.getOtherOptionsSuccess({data: response})
          }),
          catchError((response)=>{
            this.store.dispatch(setLoadingSpinner({status : false}));
            return of(fromEncodingActions.getOtherOptionsFailed({data : response?.error?.message}))
          })
        )
      )
    )
  );

  getEducationOptions$ = createEffect(
    ()=> this.actions$.pipe(
      ofType(ROUTER_NAVIGATION),
      filter((r : RouterNavigatedAction) => {
        return r.payload.routerState.url.startsWith('/home/application')
        || r.payload.routerState.url.startsWith('/home/edit-application');
      }),
      exhaustMap((action) => 
        this.encodingService.getEducationOptions().pipe(
          map((response)=>{
            console.log('getEducationOptions$', response);
            return fromEncodingActions.getEducationOptionsSuccess({data: response})
          }),
          catchError((response)=>{
            this.store.dispatch(setLoadingSpinner({status : false}));
            return of(fromEncodingActions.getEducationOptionsFailed({data : response?.error?.message}))
          })
        )
      )
    )
  );

  getOccupationOptions$ = createEffect(
    ()=> this.actions$.pipe(
      ofType(ROUTER_NAVIGATION),
      filter((r : RouterNavigatedAction) => {
        return r.payload.routerState.url.startsWith('/home/application')
        || r.payload.routerState.url.startsWith('/home/edit-application');
      }),
      exhaustMap((action) => 
        this.encodingService.getOccupationOptions().pipe(
          map((response)=>{
            console.log('getOccupationOptions$', response);
            return fromEncodingActions.getOccupationOptionsSuccess({data: response})
          }),
          catchError((response)=>{
            this.store.dispatch(setLoadingSpinner({status : false}));
            return of(fromEncodingActions.getOccupationOptionsFailed({data : response?.error?.message}))
          })
        )
      )
    )
  );

  checkDuplicateEntry$ = createEffect(
    ()=> this.actions$.pipe(
      ofType(fromEncodingActions.checkDuplicateEntry),
      exhaustMap((action) => 
        this.encodingService.checkDuplicateEntry(action?.data).pipe(
          map((response)=>{
            console.log(response);
            return fromEncodingActions.checkDuplicateEntrySuccess({data: response?.details})
          }),
          catchError((response)=>{
            this.store.dispatch(setLoadingSpinner({status : false}));
            return of(fromEncodingActions.checkDuplicateEntryFailed({data : response?.error?.message}))
          })
        )
      )
    )
  );

  checkDuplicateEntrySuccess$ = createEffect(
    ()=> this.actions$.pipe(
        ofType(fromEncodingActions.checkDuplicateEntrySuccess),
        tap(async (action) =>{
          this.store.dispatch(setLoadingSpinner({status: false}))
          const message = {
            title: 'No Existing Record Found',
            message: 'The system did not find any existing record. You may now proceed to encode the applicant’s information.'
          }
          this.modalService.successModal(message);
          console.log("checkDuplicateEntrySuccess$",action.data);
        })
      ),
    { dispatch: false }
  );

  checkDuplicateEntryFailed$ = createEffect(
    ()=> this.actions$.pipe(
        ofType(fromEncodingActions.checkDuplicateEntryFailed),
        tap(async (action) =>{
          console.log("checkDuplicateEntryFailed$",action.data);
          if(action.data){
            const message = action.data
            this.modalService.errorModal(message)
          } else{
            const message = 'Unkown error ocurred. Please try again later.'
            this.modalService.errorModal(message)
          }
        })
      ),
    { dispatch: false }
  );

  encodeApplicationEntry$ = createEffect(
    ()=> this.actions$.pipe(
      ofType(fromEncodingActions.encodeApplicationEntry),
      exhaustMap((action) => 
        this.encodingService.encodeNewApplicationEntry(action?.data).pipe(
          map((response)=>{
            console.log(response);
            return fromEncodingActions.encodeApplicationEntrySuccess({data: response?.details})
          }),
          catchError((response)=>{
            this.store.dispatch(setLoadingSpinner({status : false}));
            return of(fromEncodingActions.encodeApplicationEntryFailed({data : response?.error?.message}))
          })
        )
      )
    )
  );

  encodeApplicationEntrySuccess$ = createEffect(
    ()=> this.actions$.pipe(
        ofType(fromEncodingActions.encodeApplicationEntrySuccess),
        tap(async (action) =>{
          console.log("checkDuplicateEntrySuccess$",action.data);
          this.store.dispatch(setLoadingSpinner({status: false}));
          this.store.dispatch(getApplicantDetails({uuid: action?.data?.masterId, redirect: true, tranType: 'create'}));
          const message = {
            title: 'Success',
            message: 'New application encoded successfully!'
          }
          this.router.navigateByUrl('/home/queue');
          this.modalService.successModal(message);
        })
      ),
    { dispatch: false }
  );

  encodeApplicationEntryFailed$ = createEffect(
    ()=> this.actions$.pipe(
        ofType(fromEncodingActions.encodeApplicationEntryFailed),
        tap(async (action) =>{
          console.log("encodeApplicationEntryFailed$",action.data);
          if(action.data){
            const message = action.data
            this.modalService.errorModal(message)
          } else{
            const message = 'Unkown error ocurred. Please try again later.'
            this.modalService.errorModal(message)
          }
        })
      ),
    { dispatch: false }
  );


  updateApplicationEntry$ = createEffect(
    ()=> this.actions$.pipe(
      ofType(fromEncodingActions.updateApplicationEntry),
      exhaustMap((action) => 
        this.encodingService.updateApplicationEntry(action?.uuid, action?.data).pipe(
          map((response)=>{
            console.log(response);
            return fromEncodingActions.updateApplicationEntrySuccess({data: response?.details})
          }),
          catchError((response)=>{
            this.store.dispatch(setLoadingSpinner({status : false}));
            return of(fromEncodingActions.updateApplicationEntryFailed({data : response?.error?.message}))
          })
        )
      )
    )
  );

  updateApplicationEntrySuccess$ = createEffect(
    ()=> this.actions$.pipe(
        ofType(fromEncodingActions.updateApplicationEntrySuccess),
        tap(async (action) =>{
          console.log("updateApplicationEntrySuccess$",action.data);
          this.store.dispatch(setLoadingSpinner({status: false}))
          const message = {
            title: 'Success',
            message: 'Application updated successfully!'
          }
          this.router.navigateByUrl('/home/queue');
          this.modalService.successModal(message);
        })
      ),
    { dispatch: false }
  );

  updateApplicationEntryFailed$ = createEffect(
    ()=> this.actions$.pipe(
        ofType(fromEncodingActions.updateApplicationEntryFailed),
        tap(async (action) =>{
          console.log("updateApplicationEntryFailed$",action.data);
          if(action.data){
            const message = action.data
            this.modalService.errorModal(message)
          } else{
            const message = 'Unkown error ocurred. Please try again later.'
            this.modalService.errorModal(message)
          }
        })
      ),
    { dispatch: false }
  );

  getDocumentsOptions$ = createEffect(
    ()=> this.actions$.pipe(
      ofType(ROUTER_NAVIGATION),
      filter((r : RouterNavigatedAction) => {
        return r.payload.routerState.url.startsWith('/home/upload-documents');
      }),
      exhaustMap((action) => 
        this.encodingService.getDocumentsOptions().pipe(
          map((response)=>{
            console.log('getDocumentsOptions$', response);
            return fromEncodingActions.getDocumentOptionsSuccess({data: response?.details})
          }),
          catchError((response)=>{
            this.store.dispatch(setLoadingSpinner({status : false}));
            return of(fromEncodingActions.getDocumentOptionsFailed({data : response?.error?.message}))
          })
        )
      )
    )
  );

  constructor(
    private actions$: Actions,
    private store: Store<AppState>,
    private encodingService: EncodingService,
    private modalService: ModalService,
    private router: Router
  ) {}
}
